import React, { useEffect, useState } from 'react';
import { Button, Col, Tabs } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { CommonLayout } from 'common/components/Layouts/CommonLayout';
import { ELayoutSize } from 'common/const/common.const';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';
import { ERoutesPrivate } from 'common/models/routesModel';
import { GeneralBitecoinSettings } from 'entities/Bitecoin/components/GeneralBitecoinSettings';
import { bitecoinRewardCategoryTableConfig } from 'entities/Bitecoin/Bitecoin.const';
import { BitecoinRewardCategoryTable } from 'entities/Bitecoin/components/BitecoinRewardCategoryTable';
import { BitecoinRewards } from 'entities/Bitecoin/components/BitecoinRewards';

export enum EBitecoinPageTabKeys {
  GeneralSettings = 'generalSettings',
  RewardCategories = 'rewardCategories',
  RewardItems = 'rewardItems',
}

enum EBitecoinPageTabName {
  GeneralSettings = 'General Settings',
  RewardCategories = 'Reward Categories',
  RewardItems = 'Reward Items',
}

export const BitecoinPage: React.FC = () => {
  const history = useHistory();
  const [tab, setTab] = useState(EBitecoinPageTabKeys.GeneralSettings);
  const filter = queryToObject({ tab: undefined, pageIndex: undefined, status: undefined, search: undefined }) as {
    tab?: string;
    pageIndex?: number;
    status?: string;
    search?: string;
  };

  const selectTab = (parsedQueryTab?: string) => {
    switch (parsedQueryTab) {
      case EBitecoinPageTabKeys.GeneralSettings:
        return EBitecoinPageTabKeys.GeneralSettings;

      case EBitecoinPageTabKeys.RewardCategories:
        return EBitecoinPageTabKeys.RewardCategories;

      case EBitecoinPageTabKeys.RewardItems:
        return EBitecoinPageTabKeys.RewardItems;

      default:
        return EBitecoinPageTabKeys.GeneralSettings;
    }
  };

  const onTabChange = (tab?: string) => {
    const newTab = selectTab(tab);

    setTab(newTab);

    history.replace({ search: objectToQuery({ ...filter, tab: newTab }) });
  };

  useEffect(() => {
    onTabChange(filter.tab);
  }, []);

  return (
    <CommonLayout typeLayout={ELayoutSize.Large} classStyle="mt-10">
      <Tabs onChange={onTabChange} type="card" activeKey={tab}>
        <Tabs.TabPane tab={EBitecoinPageTabName.GeneralSettings} key={EBitecoinPageTabKeys.GeneralSettings}>
          <GeneralBitecoinSettings />
        </Tabs.TabPane>
        <Tabs.TabPane tab={EBitecoinPageTabName.RewardCategories} key={EBitecoinPageTabKeys.RewardCategories}>
          <Col span={24} className="mt-4 mb-8">
            <Link to={ERoutesPrivate.BitecoinRewardCategoryCreate}>
              <Button type="primary" title="Add category">
                Add category
              </Button>
            </Link>
          </Col>
          <Col span={12}>
            <BitecoinRewardCategoryTable config={bitecoinRewardCategoryTableConfig} />
          </Col>
        </Tabs.TabPane>
        <Tabs.TabPane tab={EBitecoinPageTabName.RewardItems} key={EBitecoinPageTabKeys.RewardItems}>
          <BitecoinRewards />
        </Tabs.TabPane>
      </Tabs>
    </CommonLayout>
  );
};
